import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { ltGtMediaQuery } from 'root/src/client/web/commonStyles'

const style = {
	root: {
		width: '100%',
		maxWidth: 842,
		margin: [[0, 'auto']],
		'@media(max-width: 1155px)': {
			padding: [[0, 20]],
		},
		[ltGtMediaQuery]: {
			padding: 0,
		},
	},
	[ltGtMediaQuery]: {
		width: '100%',
		maxWidth: 'initial',
	},
}

const CommentWrapper = ({ children, classes }) => (
	<div className={classes.root}>
		{children}
	</div>
)

export default withStyles(style, { name: 'MuiCommentWrapper' })(CommentWrapper)
